import {FormBuilder, Validators} from '@angular/forms';
import {AppointmentFiltersModel} from '../models/appointment-filters.model';

export class AppointmentSelectionFormFactory {
  static createAppointmentFiltersForm(fb: FormBuilder, appointmentFilters: AppointmentFiltersModel) {
    return fb.group({
      categoryId: [appointmentFilters.categoryId, Validators.required],
      employeeId: [appointmentFilters.employeeId, Validators.required],
    });
  }

  static createTimeSlotForm(fb: FormBuilder) {
    return fb.group({
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
    });
  }
}
